const MY_FLEET_SUBPAGE = {
  pageTitle: 'Gestão de Frota',
  tabBar: {
    generalReport: 'Relatório Geral',
    managePeople: 'Gerenciar Pessoas',
    paymentModel: 'Modelos de Pagamento',
  },
}

export default MY_FLEET_SUBPAGE
